<template>
    <div class="com-card">
        <div class="com-card-title">{{ payload.name }}<span class="right-txt">¥{{ payload.price }}{{ $getSpecialReligiousAssemblyRecord([297]).includes(payload.id) ? '/盏' : '' }}</span></div>
        <div class="com-card-content">
            <div class="text-wrap com-text-justify">
                <div v-html="payload.brief?.replace(/\n/gi, '<br>')" />
            </div>
            <br>
            <div class="van-hairline--bottom" />
            <br>
            <div class="com-form-wrap">
                <van-form>
                    <van-field
                        class="field-yellow"
                        :label="isPray ? '祈福时间' : '供灯时间'"
                        readonly
                        colon
                    >
                        <template #input>
                            {{ payload.date }}
                        </template>
                    </van-field>
                    <van-field
                        class="field-yellow"
                        :label="isPray ? '祈福位置' : '供灯位置'"
                        readonly
                        colon
                    >
                        <template #input>
                            <DictionaryText typeCode="jiNianRiWeiZhi" :dictValue="payload.location"/>
                        </template>
                    </van-field>
                    <van-field
                        label="供灯数量"
                        colon
                    >
                        <template #input>
                            <van-stepper v-model="form.quantity" />
                        </template>
                    </van-field>
                </van-form>
                <div class="com-form-submit">
                    <DefaultBtn @click="unifiedOrder">登记信息</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DictionaryText from '@/components/common/DictionaryText'
    export default {
        props: {
            payload: Object,
            default: () => {}
        },
        data () {
            return {
                showPicker: false,
                form: {
                    quantity: 1
                }
            }
        },
        methods: {
            // 跳转登记信息页面
            unifiedOrder () {
                // 以时间戳为key，存储页面数据
                const timestamp = Date.now()

                localStorage.setItem(timestamp, JSON.stringify({
                    type: 1,
                    price: this.payload.price,
                    quantity: this.form.quantity,
                    pId: this.payload.id,
                    pageData: this.payload
                }))
                this.$router.push({
                    path: 'record',
                    query: { timestamp }
                })
            }
        },
        computed: {
            // 是否为祈福项目
            isPray () {
                return this.payload?.name.indexOf('祈福') != -1
            }
        },
        components: {
            DictionaryText
        }
    }
</script>